//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

/** Status of the question */
export enum QuestionStatus {
	/** Not started yet */
	NotStarted = 0,
	/** User answered correctly */
	Correct = 1,
	/** User answered incorrectly */
	Incorrect = 2
}
